var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkButton = LinkButton;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["onClick", "children", "isMobile", "display"];
var _templateObject,
  _jsxFileName = "/Users/natalia.silva/Documents/OLX-PROJECTS/chatmod-react-components/packages/web/src/components/atoms/LinkButton/index.js";
var Link = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: ", ";\n  font-size: ", ";\n  cursor: pointer;\n  font-weight: var(--font-weight-semibold);\n  text-decoration: underline;\n  color: var(--color-secondary-100);\n  outline: none;\n\n  &:focus {\n    box-shadow: 0 0 0 2px var(--color-secondary-90);\n    border-radius: var(--border-radius-xxs);\n  }\n"])), function (props) {
  return props.display || 'block';
}, function (props) {
  return props.fontSize;
});
function LinkButton(_ref) {
  var onClick = _ref.onClick,
    children = _ref.children,
    isMobile = _ref.isMobile,
    display = _ref.display,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return (0, _jsxRuntime.jsx)(Link, Object.assign({
    role: "button",
    tabIndex: "0",
    onClick: onClick,
    fontSize: isMobile ? 'var(--font-size-xxs)' : 'var(--font-size-xs)',
    display: display
  }, props, {
    children: children
  }));
}